<action class="button-10 icon-button "
        [icon]="inWishlist ? 'wishlist-fill' : 'wishlist'"
        [iconOnly]="true"
        [status]="status"
        notification="Wishlist error"
        (click)="toggle()"
        cy-wishlistAddBtn>
</action>